<div #calendarPanel class="wrapper">

  @if (showingCalendar$ | async) {
    <!-- Special calendar states indicator -->
    @if (calendarState != CalendarState.normal) {
      <div
        class="feedback-container"
        >
        @switch (calendarState) {
          @case (CalendarState.loadError) {
            <div
              class="error-feedback-container"
              >
              <p>
                {{'calendar.contentPanel.load.error' | translate }}
              </p>
              <button (click)="retryClick()" class="retryButton">
                <p>
                  {{'general.tryAgain' | translate }}
                </p>
              </button>
            </div>
          }
          @case (CalendarState.loading) {
            <tun-loader-v5 class="loader"></tun-loader-v5>
          }
          @case (CalendarState.clearingCurrentDay) {
            <tun-loader-v5 text="clearing day .."></tun-loader-v5>
          }
          @case (CalendarState.creating) {
            <tun-loader-v5 text="calendar.contentPanel.create.busy"></tun-loader-v5>
          }
          @case (CalendarState.creatingCopy) {
            <tun-loader-v5 text="calendar.contentPanel.createCopy.busy"></tun-loader-v5>
          }
          @case (CalendarState.deleting) {
            <tun-loader-v5 text="calendar.contentPanel.delete.busy"></tun-loader-v5>
          }
          @case (CalendarState.undoingDelete) {
            <tun-loader-v5 text="calendar.contentPanel.undoDelete.busy"></tun-loader-v5>
          }
          @case (CalendarState.copyingDay) {
            <tun-loader-v5 text="calendar.contentPanel.copyDay.busy"></tun-loader-v5>
          }
          @case (CalendarState.deleted) {
            <div
              class="error-feedback-container"
              >
              <p translate>calendar.contentPanel.delete.done</p>
              <button (click)="onBack()" class="retryButton">
                <p translate>playlist.status.deleted.close</p>
              </button>
            </div>
          }
        }
      </div>
    }
    <!-- normal calendar content-->
    @if (calendarState == CalendarState.normal) {
      <div class="normalContent">
        <tun-timeline-view
          #timeLineView
          class="left-side"
          [currentTimeMultiplier]="currentTimeMultiplier"
          [hours]="hours"
        ></tun-timeline-view>
        <div class="animation-container" [style.height.rem]="24*CALENDAR_ITEM_BASE_HEIGTH_REM">
          @for (day of daysOfWeek; track day; let dayIndex = $index) {
            @if (dayIndex === currentIndex) {
              <div
                class="calendar-items-columns"
              [@carousel]="{
                value: animationDirection,
                params: {
                  duration: CAROUSEL_DURATION
                }
              }"
              >
              <div class="first-column" #column>
                @if (editMode$ | async) {
                  @for (hour of hoursForDropdown; track hour; let i = $index) {
                    <tun-create-calendar-item
                      [time]="hour"
                      [position]="1"
                      [style.pointer-events]="(isMouseDown$ | async) ? 'none' : 'all'"
                      (createMusicChannelCalendarItem)="onCreateMusicChannelCalendarItem($event)"
                      (createPlaylistCalendarItem)="onCreatePlaylistCalendarItem($event)"
                      >
                    </tun-create-calendar-item>
                    <tun-create-calendar-item
                      [time]="hour + 0.5"
                      [position]="1"
                      [style.pointer-events]="(isMouseDown$ | async) ? 'none' : 'all'"
                      (createMusicChannelCalendarItem)="onCreateMusicChannelCalendarItem($event)"
                      (createPlaylistCalendarItem)="onCreatePlaylistCalendarItem($event)"
                      >
                    </tun-create-calendar-item>
                  }
                }
                <!--
                <ng-container *ngIf="inEditMode">
                  <ng-container
                    *ngFor="let hour of hoursForDropdown; let i = index"
                    >
                    <tun-calendar-dropdown
                      (dropdown)="onDropdown($event)"
                      [style.pointer-events]="isMouseDown ? 'none' : 'all'"
                      [time]="hour"
                      [top]="heightPerItem / 2 + i * heightPerItem"
                      [position]="1"
                      (calendarItemDrop)="onCalendarItemDrop($event)"
                      (dropdownitemselect)="
                        onDropdownItemSelect($event, i, 0, 1)
                      "
                    ></tun-calendar-dropdown>
                    <tun-calendar-dropdown
                      (dropdown)="onDropdown($event)"
                      [style.pointer-events]="isMouseDown ? 'none' : 'all'"
                      [time]="hour + 0.5"
                      [top]="
                        heightPerItem / 2 +
                        i * heightPerItem +
                        heightPerItem / 2
                      "
                      [position]="1"
                      (calendarItemDrop)="onCalendarItemDrop($event)"
                      (dropdownitemselect)="
                        onDropdownItemSelect($event, i, 30, 1)
                      "
                    ></tun-calendar-dropdown>
                  </ng-container>
                </ng-container>
                -->
                @for (
                  calendarItem of showingCalendar.calendarItems
                  | calendarItemsDayPositionFilter: currentIndex:1
                  ; track
                  calendarItem) {
                  <tun-calendar-item-view
                    [calendarItem]="calendarItem"
                    [editMode]="editMode$ | async"
                    [isSelected]="isActive(calendarItem)"
                    (openTweakPanel)="onOpenTweakPanel($event)"
                    (selectMusicChannelForCalendarItem)="onSelectMusicChannel($event)"
                    (selectPlaylistForCalendarItem)="onSelectPlaylist($event)"
                    (deleteItem)="onDeleteItem($event)"
                  ></tun-calendar-item-view>
                }
              </div>
              <div class="second-column">
                <!--
                <ng-container *ngIf="inEditMode">
                  <ng-container
                    *ngFor="let hour of hoursForDropdown; let i = index"
                    >
                    <tun-calendar-dropdown
                      (dropdown)="onDropdown($event)"
                      [style.pointer-events]="isMouseDown ? 'none' : 'all'"
                      [time]="hour"
                      [top]="heightPerItem / 2 + i * heightPerItem"
                      [position]="2"
                      (calendarItemDrop)="onCalendarItemDrop($event)"
                      (dropdownitemselect)="
                        onDropdownItemSelect($event, i, 0, 2)
                      "
                    ></tun-calendar-dropdown>
                    <tun-calendar-dropdown
                      (dropdown)="onDropdown($event)"
                      [style.pointer-events]="isMouseDown ? 'none' : 'all'"
                      [time]="hour + 0.5"
                      [top]="
                        heightPerItem / 2 +
                        i * heightPerItem +
                        heightPerItem / 2
                      "
                      [position]="2"
                      (calendarItemDrop)="onCalendarItemDrop($event)"
                      (dropdownitemselect)="
                        onDropdownItemSelect($event, i, 30, 2)
                      "
                    ></tun-calendar-dropdown>
                  </ng-container>
                </ng-container>
                -->
                @if (editMode$ | async) {
                  @for (hour of hoursForDropdown; track hour; let i = $index) {
                    <tun-create-calendar-item
                      [time]="hour"
                      [position]="2"
                      [style.pointer-events]="(isMouseDown$ | async) ? 'none' : 'all'"
                      (createMusicChannelCalendarItem)="onCreateMusicChannelCalendarItem($event)"
                      (createPlaylistCalendarItem)="onCreatePlaylistCalendarItem($event)"
                      >
                    </tun-create-calendar-item>
                    <tun-create-calendar-item
                      [time]="hour + 0.5"
                      [position]="2"
                      [style.pointer-events]="(isMouseDown$ | async) ? 'none' : 'all'"
                      (createMusicChannelCalendarItem)="onCreateMusicChannelCalendarItem($event)"
                      (createPlaylistCalendarItem)="onCreatePlaylistCalendarItem($event)"
                      >
                    </tun-create-calendar-item>
                  }
                }
                @for (
                  calendarItem of showingCalendar.calendarItems
                  | calendarItemsDayPositionFilter: currentIndex:2
                  ; track
                  calendarItem) {
                  <tun-calendar-item-view
                    [calendarItem]="calendarItem"
                    [editMode]="editMode$ | async"
                    [isSelected]="isActive(calendarItem)"
                    (openTweakPanel)="onOpenTweakPanel($event)"
                    (selectMusicChannelForCalendarItem)="onSelectMusicChannel($event)"
                    (selectPlaylistForCalendarItem)="onSelectPlaylist($event)"
                    (deleteItem)="onDeleteItem($event)"
                  ></tun-calendar-item-view>
                }
              </div>
            </div>
          }
        }
      </div>
    </div>
  }
}




</div>
